module.exports = __webpack_public_path__ + "media/images/common-nav/national-parks/yosemite_national_park-82f2d0718dc1d191cc276c4681e85988.jpg";